import React from 'react';
import './DefaultSettingsPage.scss'
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import EditLocationAltOutlinedIcon from "@mui/icons-material/EditLocationAltOutlined";
import {LocationModal} from "../DealPage/LocationModal";
import Divider from "@mui/material/Divider";
import {useModalsStore} from "../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";
import {buildLocationString} from "../../utils/utils";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import classnames from "classnames";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import Switch from "@mui/material/Switch";
import {CustomSelect} from "../../components/CustomSelect";
import _ from "lodash";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {DefaultSettingsFeesAndTaxes} from "./DefaultSettingsFeesAndTaxes";
import Button from "@mui/material/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import useEnterEffect from "../../hooks/useEnterEffect";



export const DefaulSettingsPage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate, updateQuoteSettings, updateQuoteSettingsResponse } = useDefaultQuoteSettingsContext()

    const {
        openModal,
        closeModalById,
    } = useModalsStore(
        useShallow((state) => ({
            openModal: state.openModal,
            closeModalById: state.closeModalById,
        }))
    )

    const saveSettings = () => {
        return updateQuoteSettings(quoteSettings)
    }

    useEnterEffect(function saveSettingsOnEnter(){
        saveSettings()
    }, [quoteSettings])

    const saveLocation = (location, shouldSetCustomerLocation, shouldSetDealerLocation) => {
        let updateObj = {}
        if (shouldSetCustomerLocation) {
            updateObj = {
                customer_location: location,
                customer_location_id: location.id
            }
        }
        if (shouldSetDealerLocation) {
            updateObj = {
                ...updateObj,
                dealer_location: location,
                dealer_location_id: location.id
            }
        }
        if (!_.isEmpty(updateObj)) {
            setSettingsStateWithUpdate(updateObj, true)
        }

        closeModalById("LocationModal")
    }

    if (!quoteSettings) return null

    const customerLocation = quoteSettings?.customer_location
    const dealerLocation = quoteSettings?.dealer_location
    const cashName = quoteSettings.is_drive_off_cap_reduction ? 'Cap Reduction:' : 'Total Drive Off:'
    const toggleTooltipName = quoteSettings.is_drive_off_cap_reduction ? 'Total Drive Off' : 'Cap Reduction'

    const isLoading =  updateQuoteSettingsResponse?.loading

    return (
        <Box
            id={"DefaulSettingsPage"}
            style={{
                padding: isTabletOrMobile ? "29px 20px" : "29px 50px",
            }}
        >
            <Stack
                direction={'column'}
                justifyContent="space-between"
                // alignItems="center"
            >
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems={'center'}
                    style={{
                        background: "#FFFFFF",
                        marginBottom: "37px",
                        height: "61px",
                        padding: '10px 20px',
                        borderRadius: "8px",
                    }}
                >
                    <Typography
                        variant="h5"
                        component="div"
                        className={'header-title'}
                        sx={{
                            fontWeight: "700",
                            fontSize: "20px"
                    }}
                    >
                       DEFAULT LEASE QUOTE SETTINGS
                    </Typography>
                    <Button
                        onClick={saveSettings}
                    >
                        {isLoading ? (<span>Saving...</span>) : (<span>Save <KeyboardReturnIcon/></span>)}
                    </Button>
                </Stack>
                    <Stack
                        direction={isTabletOrMobile ? 'column': 'row'}
                        justifyContent="space-between"
                        alignItems={isTabletOrMobile ? 'stretch': ''}
                    >
                        <Stack
                            direction={isTabletOrMobile ? 'column': 'row'}
                            justifyContent="space-between"
                            alignItems="stretch"
                            style={{
                                marginRight: isTabletOrMobile ? '' : '20px',
                                marginBottom: isTabletOrMobile ? '20px' : ''
                            }}
                        >
                            <Box
                                className={classnames("dealPagePayment-column", {
                                    mobile: isTabletOrMobile
                                })}
                                style={{
                                    height: 'auto',
                            }}
                            >
                                <Typography
                                    gutterBottom
                                    variant="h6"
                                    component="div"
                                    className={'header'}
                                >
                                    <Stack
                                        direction={'row'}
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <span>Vehicle Pricing</span>
                                        {/*<LocalOfferOutlinedIcon/>*/}
                                    </Stack>

                                </Typography>
                                <Divider className={'divider'}/>
                                <div
                                    className={'payment-row'}
                                >
                                <span
                                    className={'payment-row_name'}
                                >
                                    Profit:
                                </span>
                                    <CustomCurrencyInput
                                        className={classnames('payment-row_value', {
                                            loading: false
                                        })}
                                        prefix="$"
                                        value={quoteSettings.profit}
                                        onChange={(value) => setSettingsStateWithUpdate({profit: value}, false)}
                                    />
                                </div>
                                <Divider />
                                <div
                                    className={'payment-row'}
                                >
                            <span
                                className={'payment-row_name'}
                            >
                                {cashName}
                                <Tooltip title={`Use cash as ${toggleTooltipName}`} arrow placement={'top'}>
                                    <Switch
                                        size={'small'}
                                        sx={{marginLeft: '5px'}}
                                        disabled={false}
                                        checked={quoteSettings.is_drive_off_cap_reduction}
                                        onChange={(value) => setSettingsStateWithUpdate(
                                            {
                                                is_drive_off_cap_reduction: !quoteSettings.is_drive_off_cap_reduction
                                            }, true)
                                        }
                                    />
                                </Tooltip>
                            </span>
                                    <CustomCurrencyInput
                                        className={classnames('payment-row_value', {
                                            loading: false
                                        })}
                                        allowNull={true}
                                        prefix="$"
                                        value={quoteSettings.drive_off}
                                        onChange={(value) => setSettingsStateWithUpdate({drive_off: value}, false)}
                                    />
                                </div>
                                <Divider/>
                                <div className={'payment-row'}>
                            <span
                                className={'payment-row_name'}
                            >
                                    Mileage:
                            </span>
                                    <CustomSelect
                                        onChange={(event, newValue) => setSettingsStateWithUpdate({mileage: newValue}, true)}
                                        className={classnames('CustomInput payment-row_value select', {
                                            loading: false
                                        })}
                                        options={[10000, 12000, 15000]}
                                        value={quoteSettings.mileage}
                                        getOptionLabel={(option) => String(option)}
                                        freeSolo
                                        forcePopupIcon
                                    />
                                </div>
                                {
                                    Boolean(quoteSettings.mileage === 10000) &&
                                    <div className={'payment-row'}>
                                <span
                                    className={'payment-row_name'}
                                    style={{display: 'flex', alignItems: 'center'}}
                                >
                                        Mileage Ford & Lincoln:
                                    <Tooltip
                                        title={'Selecting 10500 will limit the banks returned to only those offering 10500. ' +
                                            'We recommend setting to 12000 to return all banks and if needed manually changing ' +
                                            'to desired mileage later on the quote page.'}
                                    >
                                        <InfoOutlinedIcon
                                            sx={{
                                                fontSize: '19px',
                                                marginLeft: '5px'
                                            }}
                                        />
                                    </Tooltip>
                                </span>
                                        <CustomSelect
                                            onChange={(event, newValue) => setSettingsStateWithUpdate({mileage_alt: newValue}, true)}
                                            className={classnames('CustomInput payment-row_value select', {
                                                loading: false
                                            })}
                                            options={[10500, 12000, 15000]}
                                            value={quoteSettings.mileage_alt}
                                            getOptionLabel={(option) => String(option)}
                                            freeSolo
                                            forcePopupIcon
                                        />
                                    </div>
                                }
                            </Box>
                        </Stack>
                        <Box
                            className={'DealPageInfo_box'}
                            style={{
                                marginBottom: '0px',
                                width: isTabletOrMobile ? 'auto' : ''
                            }}
                        >
                            <Typography
                                gutterBottom
                                variant="h6"
                                component="div"
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: '400',
                                    marginBottom: '10px',
                                    display: "flex",
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <span>Location</span>
                                <Tooltip title="Edit Default Location" arrow placement={'top'}>

                                    <EditLocationAltOutlinedIcon
                                        sx={{cursor: 'pointer'}}
                                        className={'action-icon EditLocationIcon'}
                                        onClick={() => {
                                            openModal({
                                                element: LocationModal,
                                                id: "LocationModal",
                                                props: {
                                                    selectLocation: saveLocation,
                                                    isSaving: false,
                                                }
                                            })
                                        }}
                                    />
                                </Tooltip>
                            </Typography>
                            <Divider className={'divider'}/>
                            <Stack
                                className={''}
                                direction={'row'}
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    fontSize: '14px',
                                    color: '#666',
                                    marginBottom: '5px'
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginRight: '5px'
                                    }}
                                >
                                    Customer:
                                </label>
                                <Typography sx={{ fontSize: '14px'}}>
                                    { buildLocationString(customerLocation) }
                                </Typography>
                            </Stack>

                            <Stack
                                className={''}
                                direction={'row'}
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    fontSize: '14px',
                                    color: '#666'
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginRight: '5px'
                                    }}
                                >
                                    Dealer:</label>
                                <Typography sx={{ fontSize: '14px'}}>
                                    { buildLocationString(dealerLocation) }
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>
                </Stack>

            <DefaultSettingsFeesAndTaxes/>
        </Box>
    )
}